/**
 * 微信小程序配置
 * 请根据实际情况修改以下配置信息
 */

export const miniProgramConfig = {
  // 心电设备小程序配置
  ecg: {
    appId: 'wx5d984a32674e2a19', // 心电设备小程序AppID
    path: 'pages/index/index', // 心电设备小程序页面路径
    originalId: 'gh_27b2b7b7291c', // 心电设备小程序原始ID
    name: '心电设备蓝牙连接' // 小程序名称
  },
  
  // 其他设备小程序配置（如需要）
  watch: {
    appId: 'wx5d984a32674e2a19',
    path: 'pages/index/index',
    originalId: 'gh_27b2b7b7291c',
    name: '智能手表连接'
  },
  
  bloodPressure: {
    appId: 'wx5d984a32674e2a19',
    path: 'pages/index/index',
    originalId: 'gh_27b2b7b7291c',
    name: '血压计连接'
  }
};

/**
 * 获取指定设备类型的小程序配置
 * @param {String} deviceType - 设备类型
 * @returns {Object} 小程序配置对象
 */
export function getMiniProgramConfig(deviceType) {
  return miniProgramConfig[deviceType] || miniProgramConfig.ecg;
}

/**
 * 生成小程序跳转URL
 * @param {String} deviceType - 设备类型
 * @param {Object} extraParams - 额外参数
 * @returns {String} 跳转URL
 */
export function generateMiniProgramUrl(deviceType, extraParams = {}) {
  const config = getMiniProgramConfig(deviceType);
  const params = new URLSearchParams({
    from: 'h5',
    deviceType: deviceType,
    ...extraParams
  });
  
  return `/${config.path}?${params.toString()}`;
}



// WEBPACK FOOTER //
// ./src/config/miniProgram.js